(function(){
  var ROOT_EL = null;

  function root(){ return ROOT_EL; }
  function grid(){ return document.getElementById('product-grid'); }
  function items(g){ return Array.prototype.slice.call(g.children); }

  /* Das Raster muss mitspielen: nur die SL-Karten tragen ihr Modell am
     Element. Steht dort noch das Standardraster, wird aus jeder Pille
     schlicht ein Link auf die Modellkollektion. */
  function filterable(){
    var g = grid();
    return !!(g && g.querySelector('[data-model]'));
  }

  /* Eine Auswahl ist mehr als ein Modellname: eine Reihe kann auf eine
     Kollektion eingegrenzt sein. Bei Nike steckt in "Model: Nocta" ein Schuh
     und eine Hose — die Pille in der Schuh-Reihe traegt deshalb zusaetzlich
     "nicht aus Bekleidung", die in der Bekleidungs-Reihe "aus Bekleidung". */
  function keyOf(chip){
    return chip.getAttribute('data-model') + '|' +
           (chip.getAttribute('data-need') || '') + '|' +
           (chip.getAttribute('data-not') || '');
  }

  function indexOfKey(k){
    for (var i = 0; i < sel.length; i++){ if (sel[i].key === k) return i; }
    return -1;
  }

  function matches(li){
    var el = li.querySelector ? li.querySelector('[data-model]') : null;
    if (!el) return false;
    var m = el.getAttribute('data-model');
    var groups = el.getAttribute('data-groups') || '';
    for (var i = 0; i < sel.length; i++){
      var x = sel[i];
      if (x.m !== m) continue;
      if (x.need && groups.indexOf('|' + x.need + '|') === -1) continue;
      if (x.not && groups.indexOf('|' + x.not + '|') !== -1) continue;
      return true;
    }
    return false;
  }

  var sel      = [];
  var origHTML = null;
  var complete = false;
  var completeP = null;
  var busy     = false;
  var ownEdit  = false;
  /* Zaehler fuer den Bestand im Raster. Wird er hochgezaehlt, sind alle noch
     laufenden Nachladungen ungueltig — sonst haengt eine spaet eintreffende
     Seite ihre Karten in ein Raster, das inzwischen zurueckgesetzt wurde. */
  var gen      = 0;

  /* Welche Seiten schon im Raster haengen. Zweite Sicherung neben gen:
     selbst wenn eine Nachladung doppelt angestossen wird, kommt jede Seite
     genau einmal ins Raster. */
  var loaded = {};

  function verwerfen(){
    gen++;
    complete = false;
    completeP = null;
    origHTML = null;
    loaded = {};
  }

  /* ------------------------------------------------------ Seiten nachladen */

  function totalPages(){
    var links = document.querySelectorAll('.pagination__list a, .pagination-wrapper a');
    var max = 1;
    Array.prototype.slice.call(links).forEach(function(a){
      var m = (a.getAttribute('href') || '').match(/[?&]page=([0-9]+)/);
      if (m){ var n = parseInt(m[1], 10); if (n > max) max = n; }
      var t = parseInt((a.textContent || '').trim(), 10);
      if (!isNaN(t) && t > max) max = t;
    });
    return max;
  }

  function pageUrl(n, sectionId){
    var p = new URLSearchParams(window.location.search);
    p.set('page', n);
    p.set('section_id', sectionId);
    return window.location.pathname + '?' + p.toString();
  }

  function loadPage(n, sectionId, myGen){
    var g = grid();
    if (!g || loaded[n] || myGen !== gen) return Promise.resolve();
    loaded[n] = true;
    return fetch(pageUrl(n, sectionId), { headers: { 'Accept': 'text/html' } })
      .then(function(r){ return r.text(); })
      .then(function(html){
        if (myGen !== gen) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var src = doc.getElementById('product-grid');
        if (!src) return;
        ownEdit = true;
        items(src).forEach(function(li){ g.appendChild(document.importNode(li, true)); });
        window.setTimeout(function(){ ownEdit = false; }, 0);
      })
      .catch(function(){});
  }

  function ensureComplete(){
    if (completeP) return completeP;
    var g = grid();
    if (!g) return Promise.resolve();
    if (origHTML === null) origHTML = g.innerHTML;

    var pages = totalPages();
    var id = g.getAttribute('data-id');
    if (pages < 2 || !id){
      complete = true;
      completeP = Promise.resolve();
      return completeP;
    }

    var myGen = gen;
    setBusy(true);
    var chain = Promise.resolve();
    for (var n = 2; n <= pages; n++){
      (function(page){
        chain = chain.then(function(){ return loadPage(page, id, myGen); });
      })(n);
    }
    completeP = chain.then(function(){
      if (myGen === gen) complete = true;
      setBusy(false);
    });
    return completeP;
  }

  /* ----------------------------------------------------------- Anwenden */

  function pagination(){ return document.querySelector('.pagination-wrapper'); }

  function setBusy(on){
    busy = on;
    var st = root() && root().querySelector('[data-sl-state]');
    if (!st) return;
    st.classList.toggle('is-busy', !!on);
    if (on){ st.classList.add('is-on'); setCount('Modelle werden geladen …'); }
  }

  function setCount(text){
    var el = root() && root().querySelector('[data-sl-count]');
    if (el) el.textContent = text;
  }

  function showState(on){
    var st = root() && root().querySelector('[data-sl-state]');
    if (st) st.classList.toggle('is-on', !!on);
  }

  function apply(){
    var g = grid();
    if (!g) return;
    var pg = pagination();

    if (!sel.length){
      if (origHTML !== null){
        ownEdit = true;
        g.innerHTML = origHTML;
        verwerfen();
        window.setTimeout(function(){ ownEdit = false; }, 0);
      }
      items(g).forEach(function(li){ li.hidden = false; });
      if (pg) pg.hidden = false;
      showState(false);
      return;
    }

    showState(true);
    ensureComplete().then(function(){
      var g2 = grid();
      if (!g2) return;
      var n = 0;
      items(g2).forEach(function(li){
        var on = matches(li);
        li.hidden = !on;
        if (on) n++;
      });
      if (pagination()) pagination().hidden = true;
      setCount(n === 1 ? '1 Produkt' : n + ' Produkte');
    });
  }

  function syncChips(){
    var r = root();
    if (!r) return;
    Array.prototype.slice.call(r.querySelectorAll('[data-sl-chip]')).forEach(function(c){
      c.setAttribute('aria-pressed', indexOfKey(keyOf(c)) !== -1 ? 'true' : 'false');
    });
    /* Jede Reihe hat ihr eigenes "Alle" — es leuchtet, solange in genau
       dieser Reihe nichts gewaehlt ist. */
    Array.prototype.slice.call(r.querySelectorAll('[data-sl-row]')).forEach(function(row){
      var chips = Array.prototype.slice.call(row.querySelectorAll('[data-sl-chip]'));
      var any = false;
      chips.forEach(function(c){ if (indexOfKey(keyOf(c)) !== -1) any = true; });
      var all = row.querySelector('[data-sl-all]');
      if (all) all.setAttribute('aria-pressed', any ? 'false' : 'true');
    });
  }

  function toggle(chip){
    if (!filterable()){
      var url = chip.getAttribute('data-url');
      if (url) window.location.href = url;
      return;
    }
    var k = keyOf(chip);
    var i = indexOfKey(k);
    if (i === -1){
      sel.push({
        key:  k,
        m:    chip.getAttribute('data-model'),
        need: chip.getAttribute('data-need') || '',
        not:  chip.getAttribute('data-not') || ''
      });
    } else {
      sel.splice(i, 1);
    }
    syncChips();
    apply();
  }

  /* "Alle" raeumt nur die eigene Reihe. Steht in der einen Reihe Schuhe und
     in der anderen Bekleidung, bleibt die andere Auswahl dadurch stehen. */
  function clearRow(btn){
    var row = btn.closest ? btn.closest('[data-sl-row]') : null;
    if (!row){ clear(); return; }
    var keys = Array.prototype.slice.call(row.querySelectorAll('[data-sl-chip]')).map(keyOf);
    sel = sel.filter(function(x){ return keys.indexOf(x.key) === -1; });
    syncChips();
    apply();
  }

  function clear(){
    sel = [];
    syncChips();
    apply();
  }

  /* -------------------------------------------------------------- Leiste */

  function bindRails(r){
    Array.prototype.slice.call(r.querySelectorAll('[data-sl-row]')).forEach(bindRail);
  }

  function bindRail(row){
    var rail  = row.querySelector('[data-sl-rail]');
    var prev  = row.querySelector('[data-sl-prev]');
    var next  = row.querySelector('[data-sl-next]');
    var track = row.querySelector('[data-sl-track]');
    var thumb = row.querySelector('[data-sl-thumb]');
    if (!rail) return;

    function sync(){
      var max = rail.scrollWidth - rail.clientWidth;
      if (max < 4){
        if (prev) prev.setAttribute('data-off','');
        if (next) next.setAttribute('data-off','');
        if (track) track.setAttribute('data-off','');
        return;
      }
      if (track) track.removeAttribute('data-off');
      if (prev){ if (rail.scrollLeft <= 2) prev.setAttribute('data-off',''); else prev.removeAttribute('data-off'); }
      if (next){ if (rail.scrollLeft >= max - 2) next.setAttribute('data-off',''); else next.removeAttribute('data-off'); }
      if (thumb){
        var ratio = rail.clientWidth / rail.scrollWidth;
        var w = Math.max(12, Math.round(ratio * 100));
        thumb.style.width = w + '%';
        var travel = 100 - w;
        thumb.style.transform = 'translateX(' + (rail.scrollLeft / max) * travel + '%)';
      }
    }

    function step(dir){
      var amount = Math.max(160, Math.round(rail.clientWidth * 0.8));
      var dest = Math.max(0, Math.min(rail.scrollWidth - rail.clientWidth, rail.scrollLeft + dir * amount));
      try { rail.scrollTo({ left: dest, behavior: 'smooth' }); }
      catch (err) { rail.scrollLeft = dest; }
      window.setTimeout(sync, 320);
    }

    if (prev) prev.addEventListener('click', function(){ step(-1); });
    if (next) next.addEventListener('click', function(){ step(1); });
    rail.addEventListener('scroll', sync, { passive: true });
    window.addEventListener('resize', sync);
    sync();
    window.setTimeout(sync, 400);
  }

  /* --------------------------------------------------------- Beschreibung */

  function bindDesc(r){
    var wrap = r.querySelector('[data-sl-desc]');
    if (!wrap) return;
    var text = wrap.querySelector('[data-sl-desctext]');
    var btn  = wrap.querySelector('[data-sl-desctoggle]');
    if (!text || !btn) return;

    /* Der Knopf erscheint nur, wenn wirklich etwas abgeschnitten ist —
       sonst steht Weiterlesen unter zwei vollstaendigen Zeilen. */
    function check(){
      if (text.scrollHeight - text.clientHeight > 4) btn.hidden = false;
    }
    check();
    window.setTimeout(check, 300);
    window.addEventListener('resize', check);

    var openLabel  = btn.textContent;
    var closeLabel = wrap.getAttribute('data-less') || r.getAttribute('data-less') || 'Weniger';
    btn.addEventListener('click', function(){
      var open = wrap.classList.toggle('is-open');
      btn.textContent = open ? closeLabel : openLabel;
    });
  }

  /* -------------------------------------------------------------- Bindung */

  function init(){
    var r = document.querySelector('[data-sl-mk]');
    if (!r || r.dataset.slReady === '1') return;
    ROOT_EL = r;
    r.dataset.slReady = '1';

    bindDesc(r);
    bindRails(r);

    r.addEventListener('click', function(e){
      var t = e.target;
      if (!t || !t.closest) return;
      var chip = t.closest('[data-sl-chip]');
      if (chip){ e.preventDefault(); toggle(chip); return; }
      var all = t.closest('[data-sl-all]');
      if (all){ e.preventDefault(); clearRow(all); return; }
      if (t.closest('[data-sl-reset]')){ e.preventDefault(); clear(); }
    });

    /* Ändert jemand Filter oder Sortierung, ersetzt facets.js den Inhalt von
       #ProductGridContainer komplett. Der nachgeladene Vorrat ist dann
       hinfaellig — Auswahl neu anwenden.

       Bewusst ohne subtree und mit Vergleich der Element-Identitaet: Apps wie
       Judge.me haengen Bewertungssterne in jede frisch geladene Karte. Mit
       subtree galt das als Neuaufbau, der Abschnitt lud daraufhin wieder alle
       Seiten nach, was die naechste Runde ausloeste — die Karten vervielfachten
       sich. Ein echter Neuaufbau ist nur, wenn #product-grid ein anderes
       Element ist als vorher. */
    var container = document.getElementById('ProductGridContainer');
    var gridRef = grid();
    if (container && window.MutationObserver){
      new MutationObserver(function(){
        if (ownEdit || busy) return;
        var g = grid();
        if (g === gridRef) return;
        gridRef = g;
        verwerfen();
        if (sel.length) window.setTimeout(apply, 60);
      }).observe(container, { childList: true });
    }
  }

  if (document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', function(){ init(); });
})();